import { Injectable } from '@angular/core';
import { SharedDataService } from './shared_data.service';

@Injectable({
    // Ensures it's a singleton
    providedIn: 'root' 
})
export class LoggerService {

    private LOGS_LIST_MAX_SIZE = 1000;
    private logList: string[] = []; 

    constructor(private sharedDataService: SharedDataService) {}

    getLogList(){
        return this.logList;
    }

    debug(...args: any[]) {
        const message = args.map(arg => (typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg)).join(' ');
        if (this.sharedDataService.isDebug){
            if (this.logList.length >= this.LOGS_LIST_MAX_SIZE) {
                this.logList.shift();
            }
            this.logList.push('[DEBUG] '+message);
        }
        console.debug(message);
    }

    log(...args: any[]) {
        const message = args.map(arg => (typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg)).join(' ');
        if (this.sharedDataService.isDebug){
            if (this.logList.length >= this.LOGS_LIST_MAX_SIZE) {
                this.logList.shift();
            }
            this.logList.push('[INFO] '+message);
        }
        console.log(message);
    }

    warn(...args: any[]) {
        const message = args.map(arg => (typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg)).join(' ');
        if (this.sharedDataService.isDebug){
            if (this.logList.length >= this.LOGS_LIST_MAX_SIZE) {
                this.logList.shift();
            }
            this.logList.push('[WARN] '+message);
        }
        console.warn(message);
    }

    error(...args: any[]) {
        const message = args.map(arg => (typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg)).join(' ');
        if (this.sharedDataService.isDebug){
            if (this.logList.length >= this.LOGS_LIST_MAX_SIZE) {
                this.logList.shift();
            }
            this.logList.push('[ERROR] '+message);
        }
        console.error(message);
    }
}